<template>
  <vx-tooltip :text="$t('callback_request')" position="bottom" class="call-back-count-button-container">
    <vs-button
      class="pl-3 pr-3 mr-8 call-back-count-button"
      :color="context"
      type="filled"
      @click.prevent="$router.push({name: 'consultations.callbacks'})">
      <span v-text="callbackCount.readCallback"></span> / <span v-text="callbackCount.newCallback"></span>
    </vs-button>
  </vx-tooltip>
</template>

<script>
import Callback from '@/models/Callback'
import announcementSocket from '@/libs/sockets/announcements'

export default {
  name: 'CallbackCountButton',
  data () {
    return {
      mode: 'socket', // [sw, socket]
      callbackCount: {
        readCallback: 0,
        newCallback: 0
      }
    }
  },
  computed: {
    context () {
      if (this.callbackCount.readCallback > 0) {
        return 'danger'
      }

      if (this.callbackCount.newCallback > 0) {
        return 'warning'
      }

      return 'success'
    }
  },
  mounted () {

    if (this.mode === 'sw') {
      if (window.cbWorker) {
        window.cbWorker.terminate()
        delete window.cbWorker
      }

      window.cbWorker = new Worker('/service-worker.js')

      if (window.cbWorker) {
        window.cbWorker.postMessage({
          baseUrl: this.appConfig.apiBaseUrl
        })

        window.cbWorker.onmessage = (e) => {
          this.callbackCount = JSON.parse(e.data).callbackCount
        }
      }
    }

    if (this.mode === 'socket') {
      this.getCallbackCount()

      // TODO: Check a more efficient way, ex: listen to "this.$store.getters.announcementSocket" when connected.
      document.addEventListener('readystatechange', () => {
        if (document.readyState === 'complete' && typeof (Worker) !== 'undefined') {
          announcementSocket.getSocket().on('load_message_management', () => {
            this.getCallbackCount()
          })
          announcementSocket.getSocket().on('new_callback', () => {
            this.getCallbackCount()
          })
        }
      })

      // document.onreadystatechange = () => {
      //   console.log("state2: " + document.readyState);
      //   if (document.readyState == 'complete' && typeof (Worker) !== 'undefined') {
      //     announcementSocket.getSocket().on('new_callback', () => {
      //       console.log("got new callback signal.");
      //       this.getCallbackCount()
      //     })
      //   }
      // }
    }
  },
  methods: {
    async getCallbackCount () {
      const callbackResponse = await Callback.getCallbackCount()
      this.callbackCount = callbackResponse.data.callbackCount
    }
  }
}
</script>

<style scoped>

</style>
